import { now } from "moment";

import BackEndService from "../api/BackEndService";
import PropertyService from "../api/PropertyService";
import { generateUUIDFromID } from "../services/UUIDGeneratorService";
import { Document } from "../types/document";

type PropertyAreaProps = {
  id: string;
};

export const uploadMap = (
  event: React.ChangeEvent<HTMLInputElement>,
  propertyArea: PropertyAreaProps,
  onMapSet: (mapUrl: Document) => void
) => {
  const files = event.target.files;
  if (files && files.length > 0) {
    // Handle the selected image(s) here
    const selectedImage = files[0];

    const formData = new FormData();
    const uuid = generateUUIDFromID(now().toString());
    formData.append("uuid", uuid);
    formData.append("name", propertyArea.id);
    formData.append("file", selectedImage);

    BackEndService.UploadImage(formData)
      .then((image: any) => {
        PropertyService.UpdatePropertyArea(propertyArea.id, {
          map: image.uuid,
        })
          .then(() => {
            PropertyService.GetPropertyArea(propertyArea.id)
              .then((response) => {
                if (response.data.map) {
                  onMapSet(response.data.map);
                }
              })
              .catch((error) => {
                console.log("error fetching updated property area", error);
              });
          })
          .catch((error) => {
            console.log("error updating property area map", error);
          });
      })
      .catch((error) => {
        console.log(error);
      });
  }
};
